import React, { useState } from "react"; 
import "./AddContacts.css";
import axiosInstance from "../../../../Config/axiosInstance";

const AddContactPopup = ({ isOpen, onClose, onAddContact, supplierId }) => {
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const handleSubmit = async () => {
    // Verificare câmpuri goale
    if (!name || !email || !phone || !role) {
      alert("All fields are required.");
      return;
    }

    let hasError = false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("**Please enter a valid email address.");
      hasError = true;
    } else {
      setEmailError("");
    }

    const phoneRegex = /^\+?[0-9]\d{1,19}$/;
    if (!phoneRegex.test(phone)) {
      setPhoneError("**Please enter a valid phone number.");
      hasError = true;
    } else {
      setPhoneError("");
    }

    if(hasError) {
      return;
    }

    const newContact = {
      supplier: supplierId || null,
      name,
      position: role,
      email,
      phone,
    };

    try {
      if (supplierId) {
        const response = await axiosInstance.post('/supplier-contact/', newContact);
        console.log("Contact added successfully:", response.data);
        onAddContact(response.data);
      } else {
        onAddContact(newContact);
      }

      // Resetarea câmpurilor doar după adăugare cu succes
      setName("");
      setRole("");
      setEmail("");
      setPhone("");
      setEmailError("");
      setPhoneError("");

      onClose();
    } catch (error) {
      console.error("Error adding contact:", error.response?.data || error.message);
    }
  };

  const resetForm = () => {
    setName("");
    setRole("");
    setEmail("");
    setPhone("");
    setEmailError("");
    setPhoneError("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="contacts-overlay">
      <div className="contacts-popup">
        <h2 className="contacts-h2">Add Person Contact</h2>
        <form className="contacts-form">
          <div className="contacts-inputGroup">
            <label className="contacts-label">
              Name<span className="contacts-required-star">*</span>
            </label>
            <input
              className="contacts-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="contacts-inputGroup">
            <label className="contacts-label">
              Role<span className="contacts-required-star">*</span>
            </label>
            <input
              className="contacts-input"
              type="text"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            />
          </div>

          <div className="contacts-inputGroup">
            <label className="contacts-label">
              Email<span className="contacts-required-star">*</span>
            </label>
            <input
              className="contacts-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {emailError && <span className="contacts-error">{emailError}</span>}
          </div>

          <div className="contacts-inputGroup">
            <label className="contacts-label">
              Phone<span className="contacts-required-star">*</span>
            </label>
            <input
              className="contacts-input"
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            {phoneError && <span className="contacts-error">{phoneError}</span>}
          </div>

          <div className="contacts-buttons">
            <button
              type="button"
              className="contacts-button cancel"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              type="button"
              className="contacts-button save"
              onClick={handleSubmit}
            >
              Add Contact
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContactPopup;
